import { InfoTip } from "@/components/InfoTip";
import { formatNumber } from "@/lib/format";
import { TIPS } from "@/lib/glossary";
import type { Well } from "@/types/api";

interface Props {
  wells: Well[];
}

export function WellsCard({ wells }: Props): JSX.Element {
  return (
    <section className="card overflow-x-auto">
      <h2 className="card-title">Wells ({wells.length})</h2>
      <p className="text-xs text-ink-400 mb-3">
        Groundwater sources for this system and their characteristics.
      </p>
      {wells.length === 0 ? (
        <p className="text-sm text-ink-300">No wells in FDEP's records for this system — common for systems that purchase finished water. If a well is missing, the record needs correcting with FDEP.</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="text-left text-ink-300 border-b border-ink-700">
            <tr>
              <th className="py-2 pr-4 font-medium">Name</th>
              <th className="py-2 pr-4 font-medium">Depth (ft)</th>
              <th className="py-2 pr-4 font-medium">Year</th>
              <th className="py-2 pr-4 font-medium">Aquifer<InfoTip {...TIPS.aquifer} /></th>
              <th className="py-2 font-medium">Direct influence<InfoTip {...TIPS.gwudi} /></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-ink-700">
            {wells.map((w) => (
              <tr key={w.name}>
                <td className="py-2 pr-4 font-medium">{w.name}</td>
                <td className="py-2 pr-4 font-mono">{formatNumber(w.depth_ft)}</td>
                <td className="py-2 pr-4 font-mono">{w.year_drilled ?? "—"}</td>
                <td className="py-2 pr-4">{w.aquifer ?? "—"}</td>
                <td className="py-2">
                  {w.direct_surface_influence == null ? (
                    <span className="text-ink-300">—</span>
                  ) : w.direct_surface_influence ? (
                    <span className="pill-medium">Yes</span>
                  ) : (
                    <span className="pill-ok">No</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
